export default __webpack_public_path__ + "static/media/aksons-finance.0f76aaaa.jpg";